import { ProductTypeVerification } from '@reg/shared/model';

/**
 * Model for a product type (e.g. Apparel, Floor Pass, Raffle Ticket, Other, etc)
 */
export class ProductType {
    public static ID_ONLINE_REGISTRATION: string = '44ff4cc8-1876-4a6d-b075-534b117370bd';
    public static ID_DISCOUNT: string = 'f9684057-adf5-1585-9642-6272989a0d92';
    public id: string = null;
    public name: string = null;
    public isAddOn: boolean = null;
    public verifications: ProductTypeVerification[] = [];

    /**
     * Clone the object. This is used to prevent object reference issues
     */
    public clone(): ProductType {
        const clone: ProductType = new ProductType();
        clone.id = this.id;
        clone.name = this.name;
        clone.isAddOn = this.isAddOn;

        if (this.verifications) {
            clone.verifications = this.verifications.map((x: ProductTypeVerification) => x.clone());
        }

        return clone;
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: Object, included?: any): ProductType {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];
        const relationships: Object[] = data['relationships'] || [];

        this.id = data['id'];
        this.name = attrs['name'];
        this.isAddOn = attrs['isAddOn'];

        const verificationLinks: Object = relationships['verifications'];
        if (verificationLinks &&
            included &&
            verificationLinks['data']) {
            this.verifications = [];

            for (const verificationLink of verificationLinks['data']) {
                const verification: Object = included.filter((i: Object) => i['id'] === verificationLink['id'])[0];
                if (verification) {
                    this.verifications.push((new ProductTypeVerification()).deserialize(verification));
                }
            }
        }

        return this;
    }
}
